import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { RoomReducer } from '../../reducers/room/defaultState'
import { mediaType as MediaType } from '@bt-react/constants'
import has from 'lodash/has'

/**
 * Determines whether the presenter is hidden
 * @param state The Redux state
 */

const getCamHiddenList = (state: State): string[] => state.syncUi.videoDisplay
const getMediaType = (state: State): RoomReducer['mediaType'] => state.room.mediaType
const getMyBTID = (state: State, props): string => has(props, 'presenter.BTID') ? props.presenter.BTID : state.user.BTID
const isSidebarActive = (state: State): boolean => state.layouts.mediaLayout.mediaSidebarActive
const getIgnoreRoom = (state: State, props): boolean => props.ignoreRoom

export function isWebcamHidden (
  camHiddenList: string[],
  BTID: string,
  mediaType: RoomReducer['mediaType'],
  isSidebarActive: boolean,
  ignoreRoom: boolean
): boolean {

  const isCamHidden = camHiddenList.includes(BTID)

  if (ignoreRoom) return isCamHidden

  return (mediaType !== MediaType.WEBCAM && mediaType !== MediaType.SPOTLIGHT && !isSidebarActive || isCamHidden)

}

export default () => createSelector(
  [getCamHiddenList, getMyBTID, getMediaType, isSidebarActive, getIgnoreRoom],
  (camHiddenList, BTID, mediaType, sidebarActive, ignoreRoom): boolean =>
    isWebcamHidden(camHiddenList, BTID, mediaType, sidebarActive, ignoreRoom)
)
